/**
 * A CONFIRMAÇÃO DE SALVAR A CONFIGURAÇÃO DA DISPUTA (14/10/2026, pacote pós-pregão, visto pelo Heitor na sessão 160).
 *
 * Eram DUAS perguntas em sequência: o `window.confirm` nativo do ConfigModal ("ATENÇÃO — o robô vai lançar AGORA…",
 * quando a disputa está viva, o modo é Lance REAL e a janela de últimos segundos está desligada) e, depois dele, o modal
 * do HUB do `handleSaveConfig` ("Alterar o VALOR LIMITE (piso) com a disputa EM CURSO?"). O nativo sai; os dois avisos
 * viram UMA pergunta do HUB, que diz as consequências que valem. Nenhum dos dois avisos some: o primeiro é o da sessão
 * 131 (dois lances reais 6 s depois de virar Real com a janela desligada), o segundo muda o piso na hora.
 */
export interface SituacaoDoSalvar {
  /** Disputa viva + Lance REAL + janela de últimos segundos desligada: o lance sai no próximo ciclo. */
  vaiLancarAgora: boolean;
  /** O piso (valor limite) de algum item mudou com a disputa em curso. */
  pisoMudou: boolean;
}

export const AVISO_DE_LANCAR_AGORA =
  'O robô vai lançar AGORA: a disputa está em andamento, o modo é Lance REAL e a janela de "Lance nos últimos segundos" está DESLIGADA. '
  + 'O lance sai no próximo ciclo (segundos) e não tem como desfazer. Para guardar o lance para o fim, cancele e ligue "Lance nos últimos segundos".';

export const AVISO_DO_PISO =
  'Muda IMEDIATAMENTE até onde o robô pode baixar o lance. Piso menor = o robô passa a poder lançar mais baixo.';

/** null = salva sem perguntar. */
export function confirmacaoDoSalvarDaDisputa(s: SituacaoDoSalvar): { title: string; linhas: string[]; confirmLabel: string } | null {
  if (!s.vaiLancarAgora && !s.pisoMudou) return null;
  const linhas = [...(s.vaiLancarAgora ? [AVISO_DE_LANCAR_AGORA] : []), ...(s.pisoMudou ? [AVISO_DO_PISO] : [])];
  if (s.vaiLancarAgora && s.pisoMudou) {
    return { title: 'Salvar com a disputa EM CURSO? O robô lança agora, e o piso muda.', linhas, confirmLabel: 'Salvar e lançar' };
  }
  if (s.vaiLancarAgora) return { title: 'ATENÇÃO — o robô vai lançar AGORA. Salvar mesmo assim?', linhas, confirmLabel: 'Salvar e lançar' };
  return { title: 'Alterar o VALOR LIMITE (piso) com a disputa EM CURSO?', linhas, confirmLabel: 'Alterar piso' };
}
